import axios, { AxiosPromise } from 'axios';

import { ILotType } from '../../../@types/model/masterData/lotType/lotType';

export default class LotTypeHttpService {
    public static getLotTypeData() : AxiosPromise<Array<ILotType>> {
        return axios.get(`${API_URL}/v1/LotType/GetAllWeb`);
    }

    public static addOrUpdateLotType(data : ILotType) : AxiosPromise<ILotType> {
        return axios.post(`${API_URL}/v1/LotType/PostLotType`, data);
    }

    public static deleteLotType(lotTypeId : number) : AxiosPromise<ILotType> {
        return axios.delete(`${API_URL}/v1/LotType/Delete`, {
            params : { lotTypeId },
        });
    }
}
